<script setup lang="ts">
useHead({
  htmlAttrs: {
    class: 'bg-moss-500',
  },
})

definePageMeta({
  colorMode: 'dark',
  theme: 'moss',
  layout: 'default',
  name: 'oversikt-index',
  breadcrumb: {
    label: 'Oversikt',
  },
  alias: '/start',
})

useSeoMeta({
  title: 'Oversikt',
  description: 'Oversikt over innhold på Juridika',
})

const page = ref<number>(1)

const filterState = useSearchFilters()

const hasLicense = useHasLicense()

const searchState = useSearchState({ requestKind: 'preview', page, filters: filterState.filters, sort: filterState.sort })

const { contentTypeOptions } = useSearchFacetOptions(searchState.facets)

const filteredResults = useHighlightedResults(searchState.highlighting, searchState.searchResult, searchState.term)

useSearchHistoryTracker('global', searchState.term, searchState.searchResult, searchState.isLoading)
</script>

<template>
  <ContentDiv>
    <section class="pb-xl flex flex-col md:flex-row items-start justify-center gap-3xl pt-[40px] mx-auto max-w-[1316px]">
      <div class="flex flex-col gap-m w-full" :class="hasLicense ? ' max-w-2xl' : 'max-w-3xl'">
        <h1 class="sr-only" v-text="PAGE_TITLES.overview" />
        <h2 class="title-xl text-moss-100">
          Søk etter innhold
        </h2>
        <SearchGlobalInput
          placeholder=""
          :content-type-options="contentTypeOptions"
          :search-results="filteredResults"
          :total-results="searchState.totalResults.value"
          :is-loading="searchState.isLoading.value"
          :toggle-content-type="filterState.toggleContentType"
          :selected-content-types="filterState.selectedContentTypes.value"
          :reset-content-type="filterState.resetContentType"
          :spellcheck-suggestion="searchState.spellcheckSuggestion.value"
          class="w-full"
          :class="hasLicense ? 'max-w-[700px]' : 'max-w-[800px]'"
        />
      </div>
      <OverviewYourShortcuts v-if="hasLicense" />
    </section>
    <section class="flex flex-col items-center gap-m bg-white rounded-4xl shadow-sm pb-0 2xl:pb-m px-0 2xl:px-m -mx-m max-w-[1664px]">
      <div class="flex flex-col max-w-[1584px] w-full gap-m items-center">
        <OverviewLatestNews />
        <div class="flex xl:justify-center w-full bg-surface-secondary py-m px-m 3xl:px-0 max-w-[1584px] rounded-b-4xl 2xl:rounded-2xl">
          <OverviewPublicationList />
        </div>
      </div>
    </section>
  </ContentDiv>
</template>
